.hr {
  border: none;
}

.hr.selected {
  outline: 2px solid rgb(60 132 244);
  user-select: none;
}

.hr::after {
  content: "";
  display: block;
  height: 2px;
  background-color: #ccc;
  line-height: 2px;
}
